import { allPhotos } from "./allPhotos";

export const childrenAnniversaryPhotos = allPhotos.filter(function(obj) { return obj.type === 'Infantil'; });